<div class="da-logo" [ngClass]="{ 'da-logo-shrink': shrink }" routerLink="/">
  <span class="da-logo-devui">
    <img src="assets/devui-logo.svg" alt="Quản lý hồ sơ" />
  </span>
  <span *ngIf="!shrink" class="da-logo-text">Quản lý hồ sơ</span>
</div>
<div class="da-logo">

  <span *ngIf="!shrink" class="da-logo-text">Sở KHCN Hưng Yên</span>
</div>
